import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  Button
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import { observer, inject } from 'mobx-react';
import TableCell from '../Table/TableCell';
import componentStyles from '../Table/Table.css';
import Translation from '../Translation/Translation';

@inject('customerCaseStore')
@observer
export default class DataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      head: [],
      data: []
    }

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onSearch(event.target.value);
  }

  componentDidUpdate(prevProps) {
    if (this.props.head !== prevProps.head || this.props.data !== prevProps.data) {
      this.setState({
        head: this.props.head,
        data: this.props.data
      });
    }
  }

  render() {
    return (
      <Paper style={componentStyles.root}>
        <TextField
          id="search"
          label={<Translation>search</Translation>}
          type="search"
          margin="normal"
          onChange={event => {
            this.handleChange(event);
          }}
          style={{ marginLeft: 20, marginBottom: 20 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            )
          }}
        />

        <Table style={componentStyles.table}>
          <TableHead>
            <TableRow>
              {/* Create Table Head Row with col names */}
              {this.state.head.map(n => {
                return <TableCell key={n} cellContent={n} />;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.data.map(n => {
              return (
                <TableRow key={n._id}>
                  {Object.values(n).map(v => {
                    return <TableCell cellContent={v} />
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTable.jsx